<template>  
	<div class="headbox">
		<div class="nav">
			<div><p v-if="showPrise">联众币： {{userInfo.coin}} <span>|</span> 会员： {{userInfo.memberDays}}<span>|</span> 可转移会员： {{userInfo.transferMemberDays}}  <span>|</span> 游乐豆： {{userInfo.amusementCoin}} <span>|</span></p> <router-link to="/Notices">公告</router-link> <span>|</span> <router-link to="/Help">帮助</router-link></div>
		</div>

		<div class="userbox">
			<div class="loginbox">
				<div class="userlog"><a href="http://www.ourgame.com" target="_blank"></a></div>				
				<div class="userdlq" v-if="showPriselogin"><div class="userhome"><router-link to="/">首页</router-link></div><p><a href="http://passport.ourgame.com/passportlogin.do?from=datingboot&nexturl=http://dating.ourgame.com/lianzhong-dating-boot/auc/index.html">登录</a></p></div>

				<div class="userdlh" v-show="showRentPrise">
					<span class="span0"><router-link to="/">首页</router-link></span>
					<span class="span1"><router-link to="/myTailPays">补缴尾款<em>({{tailMoneyCount}})</em></router-link></span>
					<span class="span2"><router-link to="/MyAuc">我的拍卖</router-link></span>
					<span class="span3">{{userInfo.username}}</span>
					<span class="outbtn"><a href="http://passport.ourgame.com/lzgamelogout!webhall.do?nexturl=http://dating.ourgame.com/lianzhong-dating-boot/auc/index.html">退出登录</a></span>
				</div>
			</div>
		</div>
	</div>
</template>
<script>
	export default {
		name: "AucHeader",
		data() {
			return {
				//访问前缀，用于区分环境，访问api时使用
				service_url: process.env.VUE_APP_SERVICE_URL ? process.env.VUE_APP_SERVICE_URL : '',
				//用户携带联众币，会员天数，可转移会员天数，游乐豆个数
				userInfo:{
				username: "",
					coin: 0,
					memberDays: 0,
                    transferMemberDays: 0,
					amusementCoin: 0
				},
				//待补缴尾款个数
				tailMoneyCount: 0,
				showPrise: false,
				showPriselogin: true,
				showRentPrise: false
			};			
		},
		methods:{
			//初始化用户基本信息
			INIT_USERINFO(){
				this.$emit('INIT_USERINFO');
				this.getRequest(this.service_url + "/common/userAucInfo").then(resp => {
					if (resp) {
						this.userInfo = resp.data;
						if(resp.code == 0){
							this.showPrise = true;
							this.showPriselogin = false;
							this.showRentPrise = true;
						}else if(resp.code == 2){
							this.showPrise = false;
							this.showPriselogin = true;
							this.showRentPrise = false; 
						}
					} 
				})
			},
			//初始化待补缴尾款个数
			INIT_TAILMONEYCOUNT(){
				this.$emit('INIT_TAILMONEYCOUNT');
				this.getRequest(this.service_url + "/aucProduct/tailMoneyCount").then(resp => {
					if (resp) {
						this.tailMoneyCount = resp.data;
					} 
				})
			}
		},
		created(){
			//组件加载调用初始化
			this.INIT_USERINFO();
			this.INIT_TAILMONEYCOUNT();
		},
		components: {
			
		}
	};
</script>
<style>
	.headbox { height: 90px; }
	.nav { background:#414141; height:25px; }
	.nav div { width: 1008px; height:25px; overflow: hidden; list-style: none; margin:0 auto; color: #b9b9b9; line-height: 25px; text-align: right; font-size: 14px; }
	.nav div span { padding: 0 10px; }
	.nav div p { width: 918px; text-align: right; float: left; }
	.nav div a { color: #b9b9b9; text-decoration: none; }

	.userbox { height: 65px; background: #fff; }
	.loginbox { width: 1008px; height:65px; margin:0 auto; overflow: hidden; }
	.userlog { width: 321px; height: 65px; float: left; }
	.userlog a { display: block;width: 321px; height: 65px; background:url("../assets/img/logo.jpg") repeat; }

	.userdlq { width: 200px; height: 65px; line-height: 65px; text-align: center; float: right; position: relative; }
	.userdlq .userhome { width: 35px; position: absolute; right: 114px; bottom: 0px; text-align: center; }
	.userdlq .userhome a { color: #666; text-decoration: none; font-size: 14px; }
	.userdlq p { cursor: pointer; text-align: right; float: right; width: 84px; height: 30px; color: #fff; text-align: center; line-height: 30px; background: #d90000;border-radius: 30px; margin-top: 18px; }
	.userdlq p a { color: #fff; text-decoration: none; }

	.userdlh { width: 470px; height: 65px; line-height: 65px; text-align: center; float: right; overflow: hidden; }	
	.userdlh span { color: #666; line-height: 65px; text-align: center; font-size: 14px; display: block; float: left; }
	.userdlh span em { color: #db0000; font-style: normal; }
	.userdlh span a { color: #666; text-decoration: none; }
	.userdlh .span0 { width: 85px; float: left; text-align: center; }
	.userdlh .span0 a { color: #666; text-decoration: none; font-size: 14px; }
	.userdlh .span1 { width: 100px; }
	.userdlh .span2 { width: 100px; }
	.userdlh .span3 { width: 100px; overflow: hidden; text-overflow: ellipsis; white-space: nowrap; }
	.userdlh .outbtn { width: 84px; height: 30px; color: #fff; text-align: center; line-height: 30px; background: #d90000;border-radius: 30px; margin-top: 16px; }
	.userdlh .outbtn a { color: #666; text-decoration: none; display: block; width: 84px; height: 30px; color: #fff; text-align: center; line-height: 30px; }
</style>